<template>
  <div id="chart">
    <apexchart type="pie" width="300" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>
<script>
  import VueApexCharts from 'vue-apexcharts'
  export default {
    name: "Gender",
    props: ['getseries'],
    components: {
      apexchart: VueApexCharts,
    },
    data() {
      return {
        series: this.getseries,
        chartOptions: {
          chart: {
            width: 380,
            type: 'pie',
          },
          labels: ['ذكور', 'إناث'],
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: '100%'
              },
              legend: {
                position: 'bottom'
              }
            }
          }]
        },
      }
    },
    created() {

    },
  }
</script>

<style lang="scss" scoped>

</style>
